// src/components/SuccessScreen.js
import React from "react";
import Header from "./Header";

const SuccessScreen = () => {
  return (
    <div>
      <Header />
      <div className="center flex flex-col items-center h-screen">
        <div className="flex flex-col items-start justify-center w-full h-screen gap-6 max-w-xs md:max-w-md">
          <h2 className="text-xl md:text-2xl font-bold text-[#0D3C26]">Thank you! You're all set now!</h2>
          <p className="text-base md:text-xl text-[#0D3C26]">
            We will send you personalized tutorials every day to your email.
            Come back to use with more goals!
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuccessScreen;
